import { render } from "./PasswordForm.vue?vue&type=template&id=2d32f6d5"
import script from "./PasswordForm.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./PasswordForm.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script